angular.module('impactx.orderconfirmation').controller('OrderConfirmationSupplierCtrl', [
    '$scope',
    'dataGen',
    '$controller',
    '$routeParams',
    'ToolbarService',
    OrderConfirmationSupplierCtrl
]);

function OrderConfirmationSupplierCtrl($scope, dataGen, $controller, $routeParams) {
    var self = this;
    var parent = $controller('OrderConfirmationCtrl', {$scope: $scope});
    angular.extend(this, parent);
    var pohId = $routeParams.id;
    dataGen.getData($scope, {id: pohId}, "/orderconfirmation/viewsupplier").then(function () {
        parent.defineButtons();
    });
}